/* Ønskeliste-knappen på produktsiden (snippets/mtw-binder-button.liquid). */
(function(){
  function init(root){
  if(root.__mtwBinder) return;
  root.__mtwBinder = 1;

  var btn = root.querySelector('.mtw-binder-btn');
  var label = root.querySelector('.mtw-binder-btn-label');
  var guest = root.querySelector('.mtw-binder-guest');
  var emailIn = root.querySelector('.mtw-binder-email');
  var gmsg = root.querySelector('.mtw-binder-gmsg');
  var noteIn = root.querySelector('[data-note-in]');
  var noteOut = root.querySelector('[data-note-out]');
  var loggedIn = root.dataset.loggedIn === '1';
  var comingSoon = root.dataset.comingSoon === '1';
  var pgid = root.dataset.productGid;

  var variants = [];
  try { variants = JSON.parse((root.querySelector('.mtw-binder-vdata')||{}).textContent || '[]'); } catch(e){}

  var available = root.dataset.available === '1';
  // variant-gid (eller product-gid for gamle raekker) -> 'binder' | 'guest'.
  // Ordlyden skal matche: en gaest har ingen konto og dermed ingen oenskemappe.
  var savedGids = {};

  function savedKind(){ return savedGids[root.dataset.variantGid] || savedGids[pgid] || null; }
  function isSaved(){ return !!savedKind(); }

  function loginUrl(){
    var ret = location.pathname + location.search;
    return root.dataset.loginBase + '?return_url=' + encodeURIComponent(ret);
  }

  function refresh(){
    var kind = savedKind();
    if(kind){
      btn.classList.add('is-saved');
      label.textContent = kind === 'guest' ? 'Du får besked ✓' : 'Tilføjet til ønskelisten ✓';
      guest.hidden = true;
      return;
    }
    btn.classList.remove('is-saved');
    if(comingSoon) return; // coming soon: fast tekst og produkt-niveau
    btn.classList.toggle('mtw-binder-btn--oos', !available);
    label.textContent = available ? 'Tilføj til ønskelisten' : 'Få besked når på lager';
    if(noteIn) noteIn.hidden = !available;
    if(noteOut) noteOut.hidden = available;
    if(available){ guest.hidden = true; }
    gmsg.hidden = true;
  }

  function applyVariant(v){
    if(!v || v.gid === root.dataset.variantGid) return;
    root.dataset.variantGid = v.gid;
    root.dataset.variantTitle = v.title || '';
    root.dataset.price = String(v.price || '');
    available = comingSoon ? false : !!v.available;
    refresh();
  }

  // Temaets variantvælger skriver ?variant= med replaceState (ingen events) — poll let.
  var lastVid = null;
  setInterval(function(){
    var vid = new URLSearchParams(location.search).get('variant');
    if(vid === lastVid) return;
    lastVid = vid;
    if(!vid) return;
    for(var i=0;i<variants.length;i++){
      if(String(variants[i].id) === vid){ applyVariant(variants[i]); break; }
    }
  }, 400);

  function payload(extra){
    return Object.assign({
      productGid: pgid, variantGid: root.dataset.variantGid, variantTitle: root.dataset.variantTitle,
      title: root.dataset.title, handle: root.dataset.handle, image: root.dataset.image,
      price: parseFloat(root.dataset.price) || null, available: available
    }, extra);
  }
  function api(method, body){
    return fetch(root.dataset.proxy || '/apps/binders', {method:method, headers:{'Content-Type':'application/json'}, body: method==='GET'?undefined:JSON.stringify(body)}).then(function(r){return r.json();});
  }
  function done(msg, isGuest){
    savedGids[root.dataset.variantGid] = isGuest ? 'guest' : 'binder';
    btn.classList.add('is-saved');
    label.textContent = isGuest ? 'Du får besked ✓' : 'Tilføjet til ønskelisten ✓';
    guest.hidden = true;
    if(msg){ gmsg.textContent = msg; gmsg.style.color = ''; gmsg.hidden = false; }
  }

  btn.addEventListener('click', function(){
    if(isSaved()) return;
    if(!loggedIn){
      if(available){ window.location.href = loginUrl(); }              // på lager -> login for at gemme
      else { guest.hidden = false; emailIn.focus(); }                  // udsolgt variant -> email-form
      return;
    }
    btn.disabled = true;
    api('POST', payload({action:'add'})).then(function(res){
      btn.disabled=false;
      if(res && res.ok){ done(); }
      else { gmsg.textContent = (res && res.error) || 'Kunne ikke gemme kortet. Prøv igen.'; gmsg.style.color = '#ff7b72'; gmsg.hidden = false; }
    }).catch(function(){ btn.disabled=false; });
  });

  guest.addEventListener('submit', function(e){
    e.preventDefault();
    var email = (emailIn.value||'').trim();
    if(!email) return;
    var sub = guest.querySelector('.mtw-binder-email-btn'); sub.disabled = true;
    api('POST', {action:'subscribe', productGid:pgid, variantGid:root.dataset.variantGid, variantTitle:root.dataset.variantTitle, email:email, title:root.dataset.title, handle:root.dataset.handle}).then(function(res){
      sub.disabled = false;
      if(res && res.ok){ guest.hidden = true; done(comingSoon ? 'Du får besked når varen kan købes ✓' : 'Du får besked når den valgte stand er på lager igen ✓', true); }
      else { gmsg.textContent = (res && res.error) || 'Noget gik galt'; gmsg.hidden = false; gmsg.style.color = '#ff7b72'; }
    }).catch(function(){ sub.disabled = false; });
  });

  if(loggedIn){
    api('GET').then(function(d){
      (d.binders||[]).forEach(function(b){
        (b.items||[]).forEach(function(i){
          if(i.product_gid !== pgid) return;
          // Gamle rækker uden variant daekker hele produktet; nye daekker kun deres variant.
          savedGids[i.variant_gid || pgid] = 'binder';
        });
      });
      refresh();
    }).catch(function(){});
  }
  }
  function setup(){
    document.querySelectorAll('.mtw-binder').forEach(init);
  }
  if (document.readyState !== 'loading') setup();
  else document.addEventListener('DOMContentLoaded', setup);
  document.addEventListener('shopify:section:load', setup);
})();

/* Stand-guiden i produktsidens accordion: hentes ved første åbning (sections/mtw-stand-guide-kort.liquid), og den valgte stand markeres. */
(function(){
  var STANDS = {'near mint':1,'excellent':1,'good':1,'light played':1,'played':1,'poor':1};
  var norm = function(s){ return (s||'').trim().toLowerCase(); };
  function pick(info){
    var val = '';
    info.querySelectorAll('input, option, select').forEach(function(el){
      if (el.tagName === 'OPTION' && !el.selected) return;
      if (el.tagName === 'INPUT' && (el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
      var v = norm(el.value);
      if (STANDS[v]) val = v;
    });
    return val;
  }
  function marker(acc){
    var val = pick(acc.closest('product-info') || document);
    if (!val) return;
    acc.querySelectorAll('.mtw-sg-row').forEach(function(r){
      if (norm(r.getAttribute('data-stand')) === val) r.setAttribute('data-current','');
      else r.removeAttribute('data-current');
    });
  }
  function hent(acc){
    var plads = acc.querySelector('[data-mtw-sg-plads]');
    if (!plads || acc.__mtwSg) return;
    acc.__mtwSg = 1;
    if (typeof preLoadLoadGif === 'string') plads.innerHTML = preLoadLoadGif;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + '?section_id=mtw-stand-guide-kort', { credentials: 'same-origin' })
      .then(function(r){ if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function(t){
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var svar = doc.querySelector('[data-mtw-sg-svar]');
        if (!svar) throw new Error('tom');
        // Indsatte billeder må ikke være loading="lazy" (loader ikke på storefronten)
        svar.querySelectorAll('img[loading="lazy"]').forEach(function(i){ i.setAttribute('loading', 'eager'); });
        plads.innerHTML = svar.innerHTML;
        marker(acc);
      })
      .catch(function(){ plads.textContent = 'Guiden kunne ikke hentes. Luk og åbn igen for at prøve igen.'; acc.__mtwSg = 0; });
  }
  // Delegeret, så det overlever, at variantvælgeren gengiver sektionen på ny. toggle bobler ikke, derfor capture.
  document.addEventListener('pointerdown', function(e){
    var s = e.target.closest && e.target.closest('[data-mtw-sg-acc] > summary');
    if (s) hent(s.parentNode);
  }, true);
  document.addEventListener('toggle', function(e){
    if (e.target.matches && e.target.matches('[data-mtw-sg-acc]') && e.target.open) hent(e.target);
  }, true);
  document.addEventListener('change', function(){
    document.querySelectorAll('[data-mtw-sg-acc]').forEach(marker);
  });
})();
